<span
  data-m-target="Site plan resizer"
  class="site__sitePlan_resizer"
  (mousedown)="onMouseDown($event)"
></span>
